export default __webpack_public_path__ + "static/media/kaus-quote-2.b1973bc5.jpg";